import {useRef} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import DotsLoading from '../../../components/dotsLoading';
import HeaderBasketButton from '../../../components/headerBasketButton';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import PageLoader from '../../../components/pageLoader';
import useGetSubBrandAdvertisementsList from '../../../services/hookService/getSubBrandAdvertisementsList/useGetSubBrandAdvertisementsList';
import {useScrollV2} from '../../../utilities/hooks/useScrolling/useScrolling';
import {inputGroupNameToCode} from '../../../utilities/inputGroupCodes';
import AdvertisementCard from './advertisementCard';

const ProductShopsList = () => {
  const {inputGroupName, subBrandGuid, quantityPack, quantityPackUnit} =
    useParams();
  const navigate = useNavigate();

  const scrollDivElement = useRef<HTMLDivElement | null>(null);
  const {isScrollingDown} = useScrollV2(scrollDivElement);

  const input_group__code = inputGroupNameToCode[inputGroupName as string];

  const {data, loaderRef, isFetchingNextPage, isLoading} =
    useGetSubBrandAdvertisementsList({
      subBrandGuid: subBrandGuid,
      input_group__code: input_group__code,
      quantity_pack: (quantityPack as string) || undefined,
      quantity_pack_unit: (quantityPackUnit as string) || undefined,
    });

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="flex relative gap-2 items-center"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">انتخاب فروشگاه</span>
          </div>
        )}
        postComponent={() => <HeaderBasketButton />}
      />

      <div className="overflow-y-auto flex-1 p-6" ref={scrollDivElement}>
        {data?.map(ad => (
          <AdvertisementCard key={ad.id} item={ad} />
        ))}

        <div ref={loaderRef} className="mt-4 text-center">
          {isFetchingNextPage ? <DotsLoading /> : null}
        </div>
      </div>

      <MainFooter isScrolling={isScrollingDown} />
    </div>
  );
};

export default ProductShopsList;
